// Coordinates the mobile 3-dot menu "return" flow.
//
//   origin screen  →  open 3-dot menu  →  tap a link  →  destination screen
//   destination  --back arrow-->  origin screen, with the 3-dot menu reopened
//   3-dot menu   --Close-->       stays on the origin screen
//
// When a menu link is tapped on mobile we record where the user was (origin)
// and where the link leads (destination). The destination screen's back arrow,
// while still on that destination, navigates back to the EXACT origin path —
// explicit, not history-relative — and reopens the menu overlay. Close then
// just dismisses the overlay, leaving the user on the origin screen.
//
// Why not navigate(-1) / location.state? Both proved unreliable in this app
// (history depth and state survival vary by route), so we key off an explicit
// recorded path instead. We match on the recorded destination so the reopen
// only fires on the screen the menu actually led to.
let entry = null; // { origin: string, destination: string } | null

export const recordMenuNav = (origin, destination) => {
  entry = { origin, destination };
};

export const getMenuNav = () => entry;

export const clearMenuNav = () => {
  entry = null;
};
